import { useEffect, useRef } from "react";
import * as d3 from "d3";
import * as topojson from "topojson-client";

export default function SmallMapComponent(props) {
  const SmallMapComponentReturn = () => {
    const ref = useRef();

    var new_counties = [];
    var population_scale = [];
    [props.data].map(function (group) {
      group.map(function (item) {
        new_counties.push(item.fips_code);
        population_scale.push(item.population);
      });
    });

    population_scale.sort((a, b) => a - b);

    var scale_length = population_scale.length + 1;

    useEffect(() => {
      // Check if any counties are in Puerto Rico (FIPS codes 72xxx)
      const isPuertoRico = props.data.some(
        (county) => county.fips_code >= 72000 && county.fips_code < 73000
      );
      console.log("Is Puerto Rico:", isPuertoRico);
      console.log(
        "Counties:",
        props.data.map((c) => c.fips_code)
      );

      var width = 900,
        height = 600,
        centered;
      const svgElement = d3
        .select(ref.current)
        .append("svg")
        .attr("preserveAspectRatio", "none")
        .attr("viewBox", [0, 0, width, height]);

      const div_small = d3
        .select("body")
        .append("div")
        .attr("class", "tooltip small_tooltip")
        .style("opacity", 0);

      var path = d3.geoPath();
      if (isPuertoRico) {
        path.projection(
          d3
            .geoMercator()
            .center([-66.25, 18.25])
            .scale(15000)
            .translate([width / 2, height / 2])
        );
      }

      var colorScale = d3
        .scaleLinear()
        .domain([
          population_scale[0],
          population_scale[population_scale.length - 1],
        ])
        .range(["#c8e4fb", "#093170"]);

      // Choose JSON source based on whether territory includes PR counties
      const jsonUrl = isPuertoRico
        ? "/counties-10m.json"
        : "https://d3js.org/us-10m.v2.json";

      d3.json(jsonUrl).then((d) => {
        console.log(
          "Before filter:",
          d.objects.counties.geometries.map((g) => g.id)
        );

        d.objects.counties.geometries = d.objects.counties.geometries.filter(
          function (item) {
            return new_counties.indexOf(item.id) > -1;
          }
        );

        console.log(
          "After filter:",
          d.objects.counties.geometries.map((g) => g.id)
        );

        var geojson = topojson.feature(d, d.objects.counties);

        // Only fit projection if not Puerto Rico
        if (!isPuertoRico) {
          var projection = d3.geoIdentity().fitSize([width, height], geojson);
          path.projection(projection);
        }

        var counties = geojson.features;
        var div = d3
          .select("body")
          .append("div")
          .attr("class", "tooltip")
          .style("opacity", 0);

        svgElement
          .append("g")
          .attr("class", "zoomed-county")
          .selectAll("path")
          .data(counties)
          .enter()
          .append("path")
          .attr("d", path)
          .attr("class", "zoomed-county-hover")
          .attr("fill", function (d) {
            var to_return;
            [props.data].map(function (group) {
              group.map(function (item) {
                if (item.fips_code == d.id) {
                  to_return = colorScale(item.population);
                }
              });
            });
            return to_return;
          })
          .attr("hover_data", function (d) {
            return d.id;
          })
          .on("mouseover", function (event, t) {
            var to_return;
            [props.data].map(function (group) {
              group.map(function (item) {
                if (item.fips_code == t.id) {
                  to_return = item.population;
                }
              });
            });
            div_small.transition().duration(200).style("opacity", 0.9);
            div_small
              .html(t.properties.name + "<br>" + "Population: " + to_return)
              .style("left", d3.pointer(event, "html")[0] - 30 + "px")
              .style("top", d3.pointer(event, "html")[1] - 60 + "px");
          })
          .on("mouseout", function (d) {
            div_small.transition().duration(500).style("opacity", 0);
          });
      });
    }, [props.data]);

    return <div ref={ref} className="mapwrap special"></div>;
  };

  return <SmallMapComponentReturn />;
}
